import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { FAQ_FAQ_INDEX_SET_DATA } from 'rebook/apps/faq/constants';


export function fetchInitialData() {
  return async(dispatch, getState) => {
    const currentState = getState().faqIndex;
    dispatch(setSeoMeta());
    if (!currentState.sections) {
      await dispatch(fetchSectionList());
    }
  };
}

export function fetchSectionList() {
  return async(dispatch) => {
    return fetchQuery('/api/faq/')
      .then(({ data }) => {
        dispatch(setData({
          sections: data.objects,
        }));
      })
      .catch(({ data, resp }) => {
        Raven.captureMessage('failed to load faq list due to server error', {
          level: 'error',
          extra: {
            status: resp.status,
            response: data,
          },
        });
        throw new Error('failed to load faq list due to server error');
      });
  };
}

export function setSeoMeta() {
  return (dispatch, getState) => {
    const { booksPerSubscriptionCounter } = getState();
    dispatch(SeoActions.setData({
      title: `Вопросы и ответы об электронной библиотеке MyBook помогут вам. Читайте более ` +
      `${booksPerSubscriptionCounter.total} книг по подписке на iPhone, iPad, Android`,
      canonicalUrl: `https://${BASE_HOST}/help/`,
    }));
  };
}

export function setData(payload) {
  return {
    type: FAQ_FAQ_INDEX_SET_DATA,
    payload,
  };
}
